module.exports = __webpack_public_path__ + "img/AhaboxStory.029be3fb.png";